import { render, staticRenderFns } from "./comfirmModal.vue?vue&type=template&id=47c09876&scoped=true"
import script from "./comfirmModal.vue?vue&type=script&lang=js"
export * from "./comfirmModal.vue?vue&type=script&lang=js"
import style0 from "./comfirmModal.vue?vue&type=style&index=0&id=47c09876&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c09876",
  null
  
)

export default component.exports